import type { ApiErrorCode } from '@/services/api/generated'
import { PROBLEM_PRESENTATION } from './PROBLEM_PRESENTATION'

export const presentationFor = (code: ApiErrorCode) => PROBLEM_PRESENTATION[code]
